import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { motion } from 'framer-motion';
import './TechnologyHero.css';
import { Link as RouterLink } from 'react-router-dom';

const TechnologyHero = () => {
  return (
    <Box className="technology-hero">
      <div className="technology-hero-overlay" />
      <Container maxWidth="lg" sx={{ display: 'flex', justifyContent: 'flex-start' }}>
        <motion.div
          className="technology-hero-content"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <Typography
            variant="subtitle1"
            className="technology-hero-subtitle-top"
            component={motion.p}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            Our Expertise
          </Typography>
          <Typography
            variant="h1"
            className="technology-hero-title"
            component={motion.h1}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
          >
            TECHNOLOGY STACK
          </Typography>
          <Typography
            className="technology-hero-description"
            component={motion.p}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            We leverage cutting-edge technologies and frameworks to build scalable, 
            high-performance solutions. Our expertise spans across modern web development, 
            cloud computing, and enterprise software, ensuring your project is built with 
            the best tools for success.
          </Typography>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.5 }}
          >
            <Button 
              variant="contained" 
              color="primary" 
              size="large"
              className="technology-hero-button"
              component={RouterLink}
              to="/technologies/stack"
            >
              EXPLORE OUR STACK
            </Button>
          </motion.div>
        </motion.div>
      </Container>
    </Box>
  );
};

export default TechnologyHero; 